export const environment = {
  production: false,
  apiUrl: 'https://gmslrjsapidev.clavisco.com',
  name: 'Servicios de Integracion RJ - Sislocar Development',
  env: 'Development'
};
